import React from "react";
import PropTypes from "prop-types";

import Tooltip from "common/DS/Tooltip";
import { SHIFT_PREFERENCE } from "lib/constants";
import SVGIcon from "./SVGIcon";

export const SHIFT_DEFAULTS = {
    pref_shift_day: SHIFT_PREFERENCE.OKAY,
    pref_shift_swing: SHIFT_PREFERENCE.OKAY,
    pref_shift_night: SHIFT_PREFERENCE.OKAY,
    pref_shift_weekend: SHIFT_PREFERENCE.OKAY,
    pref_shift_overtime: SHIFT_PREFERENCE.OKAY,
};

export default class Availability extends React.PureComponent {
    static propTypes = {
        disabled: PropTypes.bool,
        handleUpdate: PropTypes.func,
        prefix: PropTypes.string,
        pref_shift_day: PropTypes.number.isRequired,
        pref_shift_swing: PropTypes.number.isRequired,
        pref_shift_night: PropTypes.number.isRequired,
        pref_shift_weekend: PropTypes.number.isRequired,
        pref_shift_overtime: PropTypes.number.isRequired,
    };

    static defaultProps = {
        disabled: false,
        handleUpdate: null,
        prefix: "",
    };

    state = {
        pref_shift_day: this.props.pref_shift_day,
        pref_shift_swing: this.props.pref_shift_swing,
        pref_shift_night: this.props.pref_shift_night,
        pref_shift_weekend: this.props.pref_shift_weekend,
        pref_shift_overtime: this.props.pref_shift_overtime,
    };

    onUpdate = () => {
        const state = {};

        const checked = this.form.querySelectorAll("input:checked");
        for (let i = 0; i < checked.length; i += 1) {
            const el = checked[i];
            state[el.name] = Number(el.value);
        }

        this.setState(state);

        if (this.props.handleUpdate) {
            this.props.handleUpdate(state);
        }
    };

    renderDayTooltip() {
        if (this.props.disabled) {
            return null;
        }

        return (
            <Tooltip title="Shifts that start between 4am and noon, e.g. 6am–4pm, 9:30am–5pm">
                <SVGIcon icon="help-circle" />
            </Tooltip>
        );
    }

    renderSwingTooltip() {
        if (this.props.disabled) {
            return null;
        }

        return (
            <Tooltip title="Shifts that start between noon and 4pm, e.g. 3:30pm–11pm, 1pm–9pm">
                <SVGIcon icon="help-circle" />
            </Tooltip>
        );
    }

    renderNightTooltip() {
        if (this.props.disabled) {
            return null;
        }

        return (
            <Tooltip title="Shifts that start between 4pm and 4am, e.g. 11pm–7am, 8pm–4am">
                <SVGIcon icon="help-circle" />
            </Tooltip>
        );
    }

    renderCheckboxes(name) {
        const { disabled, prefix } = this.props;
        const value = this.state[name];
        return [1, 2, 3, 4].map((i) => (
            <div key={i} className="availability-grid__checkbox">
                <input
                    id={`${prefix}${name}${i}`}
                    type="radio"
                    name={name}
                    value={i}
                    disabled={disabled}
                    checked={value === i}
                    onChange={this.onUpdate}
                />
                <label htmlFor={`${prefix}${name}${i}`}>
                    <SVGIcon icon="approve" />
                </label>
            </div>
        ));
    }

    render() {
        return (
            <section className="availability-grid">
                <div className="availability-grid__header">
                    <div className="availability-grid__header-empty" />
                    <div className="availability-grid__header-content">
                        <span>Definitely not</span>
                    </div>
                    <div className="availability-grid__header-content">
                        <span>Preferably not</span>
                    </div>
                    <div className="availability-grid__header-content">
                        <span>It&apos;s OK</span>
                    </div>
                    <div className="availability-grid__header-content">
                        <span>Preferred</span>
                    </div>
                </div>
                <div className="availability-grid__body">
                    <form ref={(c) => (this.form = c)}>
                        <div className="availability-grid__row">
                            <div className="availability-grid__label">
                                <span>Day shifts</span>
                                {this.renderDayTooltip()}
                            </div>
                            {this.renderCheckboxes("pref_shift_day")}
                        </div>
                        <div className="availability-grid__row">
                            <div className="availability-grid__label">
                                <span>Swing shifts</span>
                                {this.renderSwingTooltip()}
                            </div>
                            {this.renderCheckboxes("pref_shift_swing")}
                        </div>
                        <div className="availability-grid__row">
                            <div className="availability-grid__label">
                                <span>Night shifts</span>
                                {this.renderNightTooltip()}
                            </div>
                            {this.renderCheckboxes("pref_shift_night")}
                        </div>
                        <div className="availability-grid__row">
                            <div className="availability-grid__label">Weekends</div>
                            {this.renderCheckboxes("pref_shift_weekend")}
                        </div>
                        <div className="availability-grid__row">
                            <div className="availability-grid__label">Overtime</div>
                            {this.renderCheckboxes("pref_shift_overtime")}
                        </div>
                    </form>
                </div>
            </section>
        );
    }
}
